export default __webpack_public_path__ + "static/media/bg_back.5069347f.png";